module.exports = __webpack_public_path__ + "img/ico_service_tab@3x.bf3292ab.png";